"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.c = '[^aeiou]';
exports.v = '[aeiouy]';
exports.C = exports.c + '[^aeiouy]*';
exports.V = exports.v + '[aeiou]*';
exports.M_gr_0 = new RegExp('^(' + exports.C + ')?' + exports.V + exports.C);
exports.M_eq_1 = new RegExp('^(' + exports.C + ')?' + exports.V + exports.C + '(' + exports.V + ')?$');
exports.M_gr_1 = new RegExp('^(' + exports.C + ')?' + exports.V + exports.C + exports.V + exports.C);
exports.v_in_stem = new RegExp('^(' + exports.C + ')?' + exports.v);
exports.nonstd_S = /^(.+?)(ss|i)es$/;
exports.std_S = /^(.+?)([^s])s$/;
exports.E = /^(.+?)e$/;
exports.LL = /ll$/;
exports.EED = /^(.+?)eed$/;
exports.ED_or_ING = /^(.+?)(ed|ing)$/;
exports.Y = /^(.+?)y$/;
exports.nonstd_gp1 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
exports.nonstd_gp2 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
exports.nonstd_gp3 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
exports.S_or_T_with_ION = /^(.+?)(s|t)(ion)$/;
exports.has_C_and_v_but_doesnt_end_with_AEIOUWXY = new RegExp('^' + exports.C + exports.v + '[^aeiouwxy]$');